import React from 'react';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

class EditIconButton extends React.Component {
  render() {
    const { className, ariaLabel, handleClick, fetchOtherClass, changeClass } = this.props;
    return (
      <IconButton
        aria-label={ariaLabel ? ariaLabel : 'Edit'}
        color="primary"
        className={
          fetchOtherClass
            ? className
            : changeClass
            ? 'smart-edit-icon-button'
            : 'edit-icon-button ' + (className ? className : '')
        }
        onClick={handleClick}
        size="large">
        <EditIcon />
      </IconButton>
    );
  }
}

export default EditIconButton;
